import type { RoleConfig } from '../types.js';

export const spy: RoleConfig = {
  id: 'spy',
  faction: 'town',
  title: { ru: 'Шпион', uk: 'Шпигун' },
  latin: 'SPY',
  number: '18',
  accent: '#3aa7ff',
  ability: {
    ru: 'Каждую ночь узнаёт жертву мафии и проверку Дона. Дополнительно может «сесть на хвост» одному игроку — узнает все приходящие и уходящие действия.',
    uk: 'Щоночі дізнається жертву мафії та перевірку Дона. Додатково може «сісти на хвіст» одному гравцю — дізнається всі вхідні й вихідні дії.',
  },
  abilities: [
    { key: 'spy', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
